module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-nomenclature/other-kp-main-modal-nomenclature.component.sass
// module id = ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-nomenclature/other-kp-main-modal-nomenclature.component.sass
// module chunks = main